import { render } from "./Baixar.vue?vue&type=template&id=23063902"
const script = {}
script.render = render

export default script